// import { useState } from 'react';
import { LoadingMode } from '../Components/LoadingMode';
import { LiaTimesSolid } from 'react-icons/lia';

export const CloseTransaction = ({ closeTransactionData }) => {
  // const [confirmPayment, setConfirmPayment] = useState(false);
  // const [isLoading, setIsLoading] = useState(false);
  const {
    // userToken,
    // viewData,
    // handleHideCloseTransactionModal,
    // handleShowRating,
    handleOpenandCloseModal,
    confirmPayment,
    // setConfirmPayment,
    handleConfirmPayment,
  } = closeTransactionData;

  // const handleConfirmPayment = () => {
  //   setConfirmPayment(true);
  //   setIsLoading(true);
  // };
  // console.log(viewData);
  //confirm payment
  // useEffect(() => {
  //   if (confirmPayment) {
  //     const confirmPayment = async () => {
  //       try {
  //         const response = await axios.post(
  //           "https://apex.loyaltyview.com/api/payments/confirm-cx",
  //           {
  //             cx_id: viewData.id,
  //           },
  //           {
  //             headers: {
  //               Authorization: `Bearer ${userToken}`,
  //             },
  //           }
  //         );
  //         console.log(response.data, "confirm Success");
  //         toast.success("Transaction confirmed successfully !", {
  //           position: toast.POSITION.TOP_RIGHT,
  //         });
  //         setIsLoading(false);
  //         handleHideCloseTransactionModal();
  //         setConfirmPayment(false);
  //         handleShowRating();
  //       } catch (error) {
  //         console.log(error, "error in lv account");
  //         setIsLoading(false);
  //       }
  //     };
  //     confirmPayment();
  //   }
  // }, [userToken, confirmPayment]);

  return (
    <section className='fixed bg-p-bk/50 w-screen h-screen top-0 left-0 z-100 '>
      <div className=' max-w-sm bg-p-wh flex flex-col gap-3 shadow-lg rounded-lg absolute py-8 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2'>
        <h2 className='font-semibold text-[18px] border-b-hf pb-2 px-6'>
          Confirm Payment
        </h2>
        <span
          className='absolute items-center  top-8 right-6 text-2xl text-s-bk cursor-pointer hover:text-p-bk'
          onClick={() => handleOpenandCloseModal('close')}
        >
          <LiaTimesSolid />
        </span>
        <p className='px-6'>
          Please confirm that you have recieved the payment made to your bank
          account and close this transaction
        </p>

        <div className=' px-6 pt-8'>
          {/* <button
            type="button"
            className="w-fit bg-f-bk  hover:bg-s-bk/50 active:bg-t-bk/40 text-p-bk py-2.5 px-6 text-base rounded-md"
            onClick={handleHideCloseTransactionModal}
          >
            Cancel
          </button> */}
          <button
            type='button'
            className='py-2 bg-b-mc w-full text-p-wh disabled:bg-b-mct rounded-md hover:bg-b-mc/75 focus:bg-b-mc/80 text-base px-6 relative'
            disabled={confirmPayment}
            onClick={handleConfirmPayment}
          >
            Confirm
            {confirmPayment && <LoadingMode />}
          </button>
        </div>
      </div>
    </section>
  );
};
